import type { RouteRecordRaw } from 'vue-router'
import RiskProfilingPage from './RiskProfilingPage.vue'

export const riskProfilingRoutes: RouteRecordRaw[] = [
  {
    path: '/compliance/risk-LProfiling',
    name: 'compliance.riskProfiling',
    component: RiskProfilingPage,
    meta: { layout: 'admin', requiresAuth: true },
  },
]
